var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('AgentSelection',{staticClass:"q-pa-md"}),_c('Navigation',{staticClass:"q-px-md",attrs:{"ShowNextButton":"true","NextButtonColor":"primary"},on:{"NextButton":function($event){return _vm.GoToTransactionConfirmation()}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }